"use client";

import { cn } from "@/lib/utils";
import React, { ComponentProps } from "react";
import TextField from "./textField";
import { OlMinimalisticMagnifer } from "solar-icon-react/ol";
import { useSearchStore } from "@/store/searchStore";
import { cva } from "class-variance-authority";

export const searchBarVariants = cva(
  "flex h-auto w-full items-center justify-between overflow-hidden rounded-full text-base font-light pl-2 shadow-main",
  {
    variants: {
      variant: {
        default: "bg-white text-black border border-white",
        outlined: "bg-transparent text-white border-[1.5px] border-white",
        "outlined-primary":
          "bg-transparent text-primary border-[1.5px] border-primary",
      },
    },
    defaultVariants: {
      variant: "outlined",
    },
  },
);

interface Props extends ComponentProps<"div"> {
  placeholder?: string;
  variant?: "default" | "outlined" | "outlined-primary";
  query?: string;
  setQuery?: (value: string) => void;
}

const SearchBar: React.FC<Props> = ({
  placeholder = "جست و جو کنید",
  variant = "outlined",
  query: propQuery,
  setQuery: propSetQuery,
  ...props
}) => {
  const store = useSearchStore();
  const query = propQuery ?? store.query;
  const setQuery = propSetQuery ?? store.setQuery;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setQuery(query.trim());
    }
  };

  return (
    <div
      {...props}
      className={cn(searchBarVariants({ variant }), props.className)}
    >
      <TextField
        inpContainerClass="bg-transparent shadow-none"
        inputClassName={cn(
          "bg-transparent border-none text-inherit placeholder-inherit text-micro md:text-sm lg:text-base",
        )}
        className=""
        inputMode="search"
        aria-label="search"
        placeholder={placeholder}
        value={query}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setQuery(e.target.value)
        }
        onKeyDown={handleKeyDown}
      />
      <OlMinimalisticMagnifer className="ml-2 size-4! w-full lg:size-7!" />
    </div>
  );
};
export default SearchBar;
